import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import useDidMountEffect from 'assets/js/useDidMountEffect';

/* JS */
import * as Server from 'assets/js/Server';
import * as Common from 'assets/js/Common';

/* Chart */
import { Bar } from 'react-chartjs-2';
import 'chart.js/auto';

/* DatePicker */
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import moment from 'moment/moment';

const Statistics = () => {
  const today = moment();
  const monday = today.startOf('isoWeek');
  const mondayDate = monday.format('YYYY-MM-DD');

  const [search, setSearch] = useState({
    fkCustMstSeq: 0,
    startDt: mondayDate,
    endDt: moment().format('YYYY-MM-DD'),
  });
  const [custMstList, setCustMstList] = useState([{
    custMstSeq: 0,
    custName: '',
  }]);
  const [chartData, setChartData] = useState({
    labels: ['Blue', 'Red', 'Orange', 'Yellow', 'Green', 'Purple'],
    datasets: [{
      label: 'Use quantity',
      data: [12, 19, 3, 5, 2, 3],
      backgroundColor: [
        'rgba(255, 99, 132, 0.2)',
        'rgba(54, 162, 235, 0.2)',
        'rgba(255, 206, 86, 0.2)',
        'rgba(75, 192, 192, 0.2)',
        'rgba(153, 102, 255, 0.2)',
        'rgba(255, 159, 64, 0.2)',
      ],
      borderColor: [
        'rgba(255, 99, 132, 1)',
        'rgba(54, 162, 235, 1)',
        'rgba(255, 206, 86, 1)',
        'rgba(75, 192, 192, 1)',
        'rgba(153, 102, 255, 1)',
        'rgba(255, 159, 64, 1)',
      ],
      borderWidth: 1,
    }],
  });

  const options = {
    responsive: true,
    scales: {
      y: {
        beginAtZero: true,
      },
    },
  };

  useEffect(() => {
    Common.isLogin();

    getCustMstList();
  }, []);

  useDidMountEffect(() => {
    getUseQuantityList();
  }, [custMstList]);

  const handleStartDtChange = date => handleDateChange(date, true);
  const handleEndDtChange = date => handleDateChange(date, false);

  const formatDate = date => moment(date['$d']).format('YYYY-MM-DD');

  const handleDateChange = (date, isStart) => {
    const formattedDate = formatDate(date);

    setSearch(search => {
      if (isStart) {
        const isBeforeDate = moment(search.endDt).isBefore(formattedDate);

        return {
          ...search,
          startDt: formattedDate,
          endDt: isBeforeDate ? formattedDate : search.endDt,
        };
      } else {
        const isBeforeDate = moment(formattedDate).isBefore(search.startDt);

        return {
          ...search,
          startDt: isBeforeDate ? formattedDate : search.startDt,
          endDt: formattedDate,
        };
      }
    });
  };

  const getCustMstList = () => {
    Server.sendGet('client/select', {}, getCustMstListCallback).then();
  };

  const getCustMstListCallback = res => {
    setSearch(() => {
      return {
        ...search,
        fkCustMstSeq: res?.['resultList']?.[0]?.custMstSeq,
      }
    });
    setCustMstList(res?.['resultList']);
  };

  const getUseQuantityList = () => {
    Server.sendGet('product/hist', search, getUseQuantityListCallback).then();
  };

  const getUseQuantityListCallback = res => {
    const resultList = res?.['resultList'];
    const labels = [];
    const currentData = [];
    const backgroundColor = [];
    const borderColor = [];

    for (const key in resultList) {
      labels.push(resultList[key]?.productName);
      currentData.push(resultList[key]?.useQuantity);

      const rgb1 = Math.floor(Math.random() * (255 + 1));
      const rgb2 = Math.floor(Math.random() * (255 + 1));
      const rgb3 = Math.floor(Math.random() * (255 + 1));

      backgroundColor.push(`rgba(${rgb1},${rgb2},${rgb3},0.3)`);
      borderColor.push(`rgba(${rgb1},${rgb2},${rgb3},1)`);
    }

    setChartData({
      labels: labels,
      datasets: [{
        label: 'Use quantity',
        data: currentData,
        backgroundColor: backgroundColor,
        borderColor: borderColor,
        borderWidth: 1,
      }],
    });
  };

  return (
    <>
      <Inner>
        <Title>
          <TitHead>
            <i/>
            <h4>Statistics</h4>
          </TitHead>
        </Title>
        <SearchArea>
          <CateIn>
            <Cate>
              <CateSel
                name='workForm'
                id='workForm'
                value={search?.fkCustMstSeq}
                onChange={e => {
                  setSearch(() => {
                    return {
                      ...search,
                      fkCustMstSeq: e.target.value,
                    };
                  });
                }}
              >
                {custMstList?.map(item => (
                  <option key={item.custMstSeq} value={item.custMstSeq}>{item.custName}</option>
                ))}
              </CateSel>
            </Cate>
          </CateIn>
          <DateIn>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DemoContainer components={['DatePicker', 'DatePicker']}>
                <DatePicker
                  onChangeRaw={e => e.preventDefault()}
                  format={'YYYY-MM-DD'}
                  value={dayjs(search?.startDt) || ''}
                  onChange={date => handleStartDtChange(date)}
                />
              </DemoContainer>
            </LocalizationProvider>
            <i/>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DemoContainer components={['DatePicker', 'DatePicker']}>
                <DatePicker
                  onChangeRaw={e => e.preventDefault()}
                  format={'YYYY-MM-DD'}
                  value={dayjs(search?.endDt) || ''}
                  onChange={date => handleEndDtChange(date)}
                />
              </DemoContainer>
            </LocalizationProvider>
          </DateIn>
          <SearchBtn onClick={getUseQuantityList}>Search</SearchBtn>
        </SearchArea>
        <Content>
          <Bar data={chartData} options={options}/>
        </Content>
      </Inner>
    </>
  )
}

const Inner = styled.div`
  flex: 1;
  background: #ffffff;
`;

const Title = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 40px;
`;

const TitHead = styled.div`
  display: flex;
  align-items: center;
  gap: 0 10px;

  & i {
    display: block;
    width: 4px;
    height: 32px;
    border-radius: 0 2px 2px 0;
    background: #1e1e1e;
  }

  & h4 {
    font-weight: 500;
    font-size: 16px;
    color: #000000;
  }
`;

const SearchArea = styled.div`
  position: relative;
  margin-top: 35px;
  padding: 15px 20px;
  border-top: 1px solid #eeeeee;
  border-bottom: 1px solid #eeeeee;
  display: flex;
  align-items: center;
  gap: 0 15px;
  width: 100%;

  & .react-datepicker__tab-loop {
    position: absolute;
  }
`;

const CateIn = styled.div`
  display: flex;
  align-items: center;
  gap: 0 20px;
`;

const Cate = styled.div`
  display: flex;
  align-items: center;
  gap: 0 10px;

  & label {
    font-weight: 400;
    font-size: 16px;
    color: #777777;
  }
`;

const Content = styled.div`
  margin-top: 35px;
  position: relative;
  height: 622px;
  display: flex;
  justify-content: center;
`;

const DateIn = styled.div`
  display: flex;
  align-items: center;
  gap: 0 15px;

  .MuiStack-root {
    padding: 0;

    .MuiInputBase-root {
      background: #f8f8f8;
    }
  }

  & input {
    width: 116px;
    height: 40px;
    line-height: 40px;
    padding: 0 16px;
    font-weight: 400;
    font-size: 16px;
    color: #777777;
    border-radius: 5px;
    outline: none;
  }

  & i {
    display: block;
    width: 12px;
    height: 1px;
    background: rgba(0, 0, 0, 0.12);
  }

  & .react-datepicker-popper {
    width: 226px;
    z-index: 99;
  }
`;

const CateSel = styled.select`
  width: 200px;
  height: 40px;
  line-height: 40px;
  padding: 0 16px;
  font-weight: 400;
  font-size: 16px;
  color: #777777;
  background: #f8f8f8 url('https://ust-india.s3.ap-northeast-2.amazonaws.com/erp-web/sel_arrow.svg') top 50% right 10px no-repeat;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 5px;
  outline: none;
`;

const SearchBtn = styled.button`
  width: 120px;
  height: 40px;
  line-height: 40px;
  border-radius: 5px;
  background: #a4a4a4;
  font-weight: 400;
  font-size: 16px;
  color: #ffffff;

  &:hover {
    background-color: #7e7e7e;
  }
`;

export default Statistics;